import { render, staticRenderFns } from "./WebsiteFooter.vue?vue&type=template&id=4ced98e0&scoped=true&"
import script from "./WebsiteFooter.vue?vue&type=script&lang=js&"
export * from "./WebsiteFooter.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteFooter.vue?vue&type=style&index=0&id=4ced98e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ced98e0",
  null
  
)

export default component.exports